export function login(state: object = {isSubmitting: false, error: '', isLogin: localStorage.getItem('token') ? true : false}, action: any) {
    switch (action.type) {
        case 'LOGIN_ERROR':
            return Object.assign({}, state, {error: action.data})

        case 'LOGINING':
            return Object.assign({}, state, {isSubmitting: action.data})

        case 'IS_LOGIN':
            return Object.assign({}, state, {isLogin: action.data})

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Auth/Login/reducers.tsx